import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';
import { push } from 'connected-react-router';

import { RUN_DB_CLIENTS_SCORING } from '../types/runDbClientsScoringTypes';
import { runDbClientsScoringFulfilled, runDbClientsScoringPending, runDbClientsScoringRejected } from '../actions/runDbClientsScoringActions';
import { sendApiRequest } from '../../../actions/apiRequestActions';
import { notifyError, notifySuccess } from '../../../actions';
import { RUN_DB_CLIENTS_SCORING_MESSAGES } from '../constants/runDbClientsScoring';
import routesConfig from '../../../routes/routes-config';
import generateError from '../../../utilities/generateError';

const runScoringPayload = payload => ({
  method: 'get',
  url: 'scorecard/calculatedbclients',
  onSuccess: [
    runDbClientsScoringFulfilled,
    () => notifySuccess(RUN_DB_CLIENTS_SCORING_MESSAGES.SCORED_SUCCESS),
    () => push(routesConfig.uploadCsvClientsPage.path),
  ],
  onError: [
    runDbClientsScoringRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const runDbClientsScoringEpic$ = action$ => action$.pipe(
  ofType(RUN_DB_CLIENTS_SCORING.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(runDbClientsScoringPending()),
    of(sendApiRequest(runScoringPayload(payload), meta)),
  )),
);

export default runDbClientsScoringEpic$;


// WEBPACK FOOTER //
// ./src/features/score-card/epics/runDbClientsScoringEpic.js